module.exports = require("animate.css");